/**
 * The AI agents' portraits — a fixed lookup table rather than anything
 * derived from `User` data. The first six are commissioned art;
 * Daniela's was drawn to match them (gpt-image-2 through the gateway,
 * 2026-09-24), which is why the set still looks like one set. Keyed by
 * both the bot `User.id` (comments, watchers — anywhere a `Person`
 * shows up) and the `Agent.slug` (the /agents platform pages), since
 * callers reach for whichever one they already have.
 *
 * Bot identities and their ids: see prisma/migrations/
 * 20260822130000_agent_identity_unification (Hubert/Prokop/Radim),
 * 20260825091000_stanislav_to_metodej_naming (the coder persona's final
 * name — Stanislav never shipped past dev, so he has no portrait),
 * 20260902200000_argus_naming, 20260907120000_vratislav_agent and
 * 20260924020000_bookkeeper_daniela.
 */

export const AGENT_AVATAR_BY_USER_ID: Record<string, string> = {
  "user-agent-hubert": "/agents/hubert.webp",
  "user-agent-tester": "/agents/prokop.webp",
  "user-agent-reviewer": "/agents/radim.webp",
  "user-agent-metodej": "/agents/metodej.webp",
  "user-agent-log-triage": "/agents/argus.webp",
  "user-agent-vratislav": "/agents/vratislav.webp",
  "user-agent-daniela": "/agents/daniela.webp",
};

export const AGENT_AVATAR_BY_SLUG: Record<string, string> = {
  analyst: "/agents/hubert.webp",
  tester: "/agents/prokop.webp",
  reviewer: "/agents/radim.webp",
  metodej: "/agents/metodej.webp",
  "log-triage": "/agents/argus.webp",
  vratislav: "/agents/vratislav.webp",
  bookkeeper: "/agents/daniela.webp",
};
